/* Skovasken landing pages. Vanilla port of the preview's client components:
   scroll reveal (Reveal.tsx), sticky bar + buy card gating (StickyCtaBar.tsx,
   BuyCard.tsx) and the drag-to-compare slider (Compare.tsx). No library. */
(function () {
  "use strict";

  /* Reveal: fade-up as a block enters the viewport. Nested .sk-reveal children
     follow their revealed ancestor through CSS, staggered by --sk-delay. */
  function reveal() {
    var roots = document.querySelectorAll(".sk-band__inner.sk-reveal, .sk-upsell.sk-reveal");
    if (!("IntersectionObserver" in window)) {
      roots.forEach(function (el) { el.classList.add("is-visible"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add("is-visible");
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    roots.forEach(function (el) { io.observe(el); });
  }

  /* Show `el` once the element with id `anchorId` has been reached, and keep
     it shown. Without an anchor, show after 700px of scroll (page 1's bar). */
  function gate(el, anchorId) {
    if (!el) return;
    var show = function () { el.classList.add("is-visible"); el.removeAttribute("aria-hidden"); };
    if (anchorId) {
      var anchor = document.getElementById(anchorId);
      if (!anchor || !("IntersectionObserver" in window)) return;
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        if (e.isIntersecting || e.boundingClientRect.top < 0) show();
      }, { rootMargin: "0px 0px -35% 0px" });
      io.observe(anchor);
      return;
    }
    var onScroll = function () {
      if (window.scrollY > 700) show();
      else { el.classList.remove("is-visible"); el.setAttribute("aria-hidden", "true"); }
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  function furniture() {
    document.querySelectorAll(".sk-furniture").forEach(function (root) {
      var sticky = root.querySelector(".sk-sticky");
      var card = root.querySelector(".sk-buycard");
      if (sticky) {
        document.body.classList.add("sk-has-sticky");
        gate(sticky, sticky.getAttribute("data-anchor") || "");
      }
      if (card) gate(card, card.getAttribute("data-anchor") || "");
    });
  }

  /* Drag-to-compare. Pointer events with capture, a raw touch fallback for
     engines that cancel pointer streams mid-gesture (iOS Safari), and keys.
     The frame owns the gesture: touch-action none in CSS, capture on down. */
  function compare() {
    document.querySelectorAll(".sk-compare__frame").forEach(function (frame) {
      var before = frame.querySelector(".sk-compare__before");
      var handle = frame.querySelector(".sk-compare__handle");
      if (!before || !handle) return;
      var pos = 55;
      var activeId = null;

      var apply = function () {
        before.style.clipPath = "inset(0 " + (100 - pos) + "% 0 0)";
        before.style.webkitClipPath = "inset(0 " + (100 - pos) + "% 0 0)";
        handle.style.left = pos + "%";
        handle.setAttribute("aria-valuenow", String(Math.round(pos)));
      };
      var setFromX = function (clientX) {
        var r = frame.getBoundingClientRect();
        if (!r.width) return;
        pos = Math.min(100, Math.max(0, ((clientX - r.left) / r.width) * 100));
        apply();
      };
      var start = function () { frame.classList.add("is-dragging"); };
      var stop = function () { activeId = null; frame.classList.remove("is-dragging"); };

      if (window.PointerEvent) {
        frame.addEventListener("pointerdown", function (e) {
          if (e.pointerType === "mouse" && e.button !== 0) return;
          activeId = e.pointerId;
          start();
          try { frame.setPointerCapture(e.pointerId); } catch (err) {}
          setFromX(e.clientX);
          e.preventDefault();
        });
        frame.addEventListener("pointermove", function (e) {
          if (activeId === null || e.pointerId !== activeId) return;
          setFromX(e.clientX);
          e.preventDefault();
        });
        var end = function (e) {
          if (activeId === null || e.pointerId !== activeId) return;
          try { frame.releasePointerCapture(e.pointerId); } catch (err) {}
          stop();
        };
        frame.addEventListener("pointerup", end);
        frame.addEventListener("pointercancel", end);
        frame.addEventListener("lostpointercapture", function () { if (activeId !== null) stop(); });
      } else {
        // No pointer events at all: mouse plus touch.
        var down = false;
        frame.addEventListener("mousedown", function (e) { down = true; start(); setFromX(e.clientX); e.preventDefault(); });
        window.addEventListener("mousemove", function (e) { if (down) setFromX(e.clientX); });
        window.addEventListener("mouseup", function () { if (down) { down = false; stop(); } });
      }

      // Touch fallback: on iOS a pointer stream can be cancelled by the
      // scroll arbitration; raw touch events keep tracking the finger.
      frame.addEventListener("touchstart", function (e) {
        if (!e.touches.length) return;
        start();
        setFromX(e.touches[0].clientX);
        e.preventDefault();
      }, { passive: false });
      frame.addEventListener("touchmove", function (e) {
        if (!e.touches.length) return;
        setFromX(e.touches[0].clientX);
        e.preventDefault();
      }, { passive: false });
      frame.addEventListener("touchend", stop);
      frame.addEventListener("touchcancel", stop);

      frame.addEventListener("dragstart", function (e) { e.preventDefault(); });
      handle.addEventListener("keydown", function (e) {
        var step = e.shiftKey ? 10 : 4;
        if (e.key === "ArrowLeft") pos = Math.max(0, pos - step);
        else if (e.key === "ArrowRight") pos = Math.min(100, pos + step);
        else if (e.key === "Home") pos = 0;
        else if (e.key === "End") pos = 100;
        else return;
        e.preventDefault();
        apply();
      });
      apply();
    });
  }

  function init() { reveal(); furniture(); compare(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
